import React from 'react';
import Icon from '../Icon';
import { CHANNEL_META, channelVars, type Channel } from '../../utils/channel';

interface Props {
  channel: Channel;
  size?: 'md' | 'sm';
}

/** Square soft-colored icon tile that carries the channel identity. */
const ChannelBubble: React.FC<Props> = ({ channel, size = 'md' }) => {
  const meta = CHANNEL_META[channel];
  const { color, soft } = channelVars(channel);
  return (
    <span
      className={`ch-bubble${size === 'sm' ? ' sm' : ''}`}
      style={{ background: soft, color }}
      aria-label={meta.label}
    >
      <Icon name={meta.icon} size={size === 'sm' ? 16 : 20} />
    </span>
  );
};

export default ChannelBubble;
